import { generateEvent } from '../../../utils/dataGrinch';
import { readCookie } from '../../../components/common/Cookie';
import { checkFingerPrintDetails } from '../../../utils/fingerPrint.js';
// push event to clever tap
export default async function cleverTapPushEvent({ eventName, eventObj = {} }) {
  if (typeof clevertap === 'undefined') {
    return;
  }
  try {
    if (!eventObj.device_id) {
      await checkFingerPrintDetails().then(() => {
        Object.assign(eventObj, { device_id: readCookie('_fpuuid') });
      });
    }
    typeof clevertap !== 'undefined' &&
      clevertap.event &&
      clevertap.event.push(eventName, eventObj);
  } catch (error) {
    generateEvent({ Event: 'clevertap event push failed' });
  }
}

// push userProfile detail in cleverTap
export function addCleverTapUserLogin(profileResponse = {}) {
  const { firstName = '', lastName = '', identity = '', genderType = '' } = profileResponse;
  const gender = genderType === 'FEMALE' ? 'F' : 'M';
  if (typeof clevertap !== 'undefined' && clevertap.onUserLogin) {
    clevertap.onUserLogin.push({
      Site: {
        Identity: identity,
        Gender: gender,
        FirstName: firstName,
        LastName: lastName
      }
    });
  }
}

// push Locale to cleverTap profile
export function addLocaleInfoToCleverTap(response = {}) {
  const { city = '', customerType = '', pincode = '', state = '', zone = '' } = response;
  if (typeof clevertap !== 'undefined' && clevertap.profile) {
    clevertap.profile.push({
      Site: {
        City: city,
        CustomerType: customerType,
        Pincode: pincode,
        State: state,
        Zone: zone
      }
    });
  }
}
